var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ricevimento"},[_c('h1',[_vm._v("Ricevimento merci")]),_c('p',[_vm._v("Ciao")])])}]

export { render, staticRenderFns }